import React, { useState } from "react";
import { Link, AddToolTip } from "../../../components";
import { Image } from "react-bootstrap";
import { MANAGE_MASTERS_ROUTES } from "../../../utils";
import { faCross, faEdit, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FieldSetupSlider from "../../Mapper/MapAndTransformOutput/FieldSetupSlider";
import {
  DeleteAdvisorRepresentative,
  getAdvisorOrganisation,
} from "../../../services";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { isEmpty, get } from "lodash";
const AdvisorRepresentativeDetailsTile = (props) => {
  const {
    data,
    setSlider,
    advisorId,
    setEdit,
    setSliderData,
    setAdvisorRepresentatives,
  } = props;
  const [deleteTile, setDelete] = useState(false);
  const [error, setError] = useState("");
  const setData = () => {
    setSliderData(data);
    setEdit();
  };
  const deleteClearingPartner = (advisorId) => {
    DeleteAdvisorRepresentative(advisorId)
      .then((response) => {
        if (response.isSuccessful) {
          getAdvisorOrganisation(data.advisorId)
            .then((response) => {
              setAdvisorRepresentatives(
                get(response, "advisor.advisorRepresentatives", [])
              );
            })
            .catch((error) => {});
          setDelete(false);
        } else {
          setError(response?.errorMessages[0]);
        }
      })
      .catch((error) => {});
  };

  return deleteTile ? (
    <div
      className="rounded p-3 text-decoration-tile-delete"
      style={{
        display: "flex",
        marginTop: "5px",
        marginBottom: "1.5rem",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "start",
          gap: "10px",
          flexWrap: "nowrap",
          color: "black",
        }}
        onClick={() => setSlider(true)}
      >
        <div className="delete-partner-account-left-side">
          <div className="warning-icon">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              size="2x"
              color="#EB4E3D"
            />
          </div>
          <div className="delete-description-left-side">
            {!isEmpty(error) ? (
              <div> {error}</div>
            ) : (
              <>
                <div className="heading">Delete Advisor Representative</div>
                <div className="delete-warning-text">
                  Are you attempting to delete Advisor Representative?
                </div>
                <div className="clearing-partner-ID">
                  {data.clearingPartnerId}
                </div>
                <div className="description">{data.description}</div>
              </>
            )}
          </div>
        </div>
        <div className="delete-partner-account-right-side">
          {isEmpty(error) ? (
            <div
              className="delete-icon"
              onClick={() => deleteClearingPartner(data.id)}
            >
              <FontAwesomeIcon
                icon={faTrashAlt}
                style={{ alignSelf: "center" }}
              />
              <div>Delete</div>
            </div>
          ) : null}
          <div className="cancel-icon" onClick={() => setDelete(false)}>
            <FontAwesomeIcon icon={faTimes} style={{ alignSelf: "center" }} />
            <div>Cancel</div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className="rounded p-3 text-decoration-tile"
      style={{
        display: "flex",
        marginTop: "5px",
        marginBottom: "1.5rem",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "start",
          gap: "10px",
          flexWrap: "nowrap",
          color: "black",
        }}
        onClick={() => setSlider(true)}
      >
        <Link
          className="link-for-clearing-partner-account"
          to={`${MANAGE_MASTERS_ROUTES.ADVISOR_REPRESENTATIVE_PLAN_DETAILS}/${advisorId}/${data.id}`}
        >
          <div className="clearing-partner-id-detail w-40">
            <div className="main-font">{data.name ?? null}</div>
            {/* <AddToolTip name={data.name}>
              <div className="below-font">
                {data.description?.slice(0, 30)}...
              </div>
            </AddToolTip> */}
          </div>
          <div className="w-40">
            <div className="main-font">{data.associatedPlansCount}</div>
          </div>

          <div className="w-40">
            <div className="main-font">{data.number}</div>

            {/* <div className="below-font">{data.accountNumber}</div> */}
          </div>
        </Link>
        <div className="clearing-partner-actions w-10">
          {/* <div className="below-font">{data.amount}</div> */}
          <div className="clearing-partner-account-edit-icon" onClick={setData}>
            <FontAwesomeIcon icon={faEdit} />
          </div>
          <div
            className="clearing-partner-account-delete-icon"
            onClick={() => setDelete(true)}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvisorRepresentativeDetailsTile;
